// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import listIcon from "@/assets/icons/list.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ListIconProps = Omit<IconProps, "name">;

export function ListIcon(props: ListIconProps): React.ReactNode {
  return <Icon name={listIcon} {...props} />;
}
